module.exports = __webpack_public_path__ + "static/media/ad2.3b673d7b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Practice/Material/ad2.jpg
 ** module id = 132
 ** module chunks = 0
 **/